import { render } from "./lineCharts.vue?vue&type=template&id=38b6fbcc"
import script from "./lineCharts.vue?vue&type=script&lang=js"
export * from "./lineCharts.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/statistics/lineCharts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38b6fbcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38b6fbcc', __exports__)) {
    console.log('reload')
    api.reload('38b6fbcc', __exports__)
  }
  
  module.hot.accept("./lineCharts.vue?vue&type=template&id=38b6fbcc", () => {
    console.log('re-render')
    api.rerender('38b6fbcc', render)
  })

}


export default __exports__